import Departments from "./pages/Departments";

export const Routes = {
    // pages
    Presentation: { path: "/" },
    DashboardOverview: { path: "/dashboard/overview" },
    Reports: { path: "/reports" },
    Transactions: { path: "/transactions" },
    Settings: { path: "/settings" },
    Admin: { path: "/admin" },
    CreateAdmin: { path: "/create-admin" },
    EditAdmin: { path: "/edit/admin/:id" },
    Customers: { path: "/customers" },
    CreateCustomers: { path: "/create-customers" },
    EditCustomers: { path: "/edit/customer/:id" },
    Branches: { path: "/branches" },
    SoftBranches: { path: "/bdeleted" },
    CreateBranch: { path: "/create-branch" },
    EditBranch: { path: "/edit/branch/:id" },
    Product: { path: "/product" },
    CreateProduct: { path: "/create-product" },
    EditProduct: { path: "/edit/category/:id" },
    Company: { path: "/company" },
    CompanySettings: { path: "/company-settings/:id" },
    CompanySettingsListing: { path: "/company-settings" },
    SoftCompany: { path: "/cdeleted" },
    CreateCompany: { path: "/create-company" },
    EditCompany: { path: "/edit/company/:id" },
    Quotes: { path: "/quotes" },
    CreateQuotes: { path: "/create-quote" },
    EditQuotes: { path: "/edit/quote/:id" },
    ConvertPoSales: { path: "/convert-po-sales/:id" },
    PoSales: { path: "/po-sales" },
    PaymentTerms: { path: "/payment-terms" },
    CreatePaymentTerm: { path: "/create-payment-term" },
    EditPaymentTerm: { path: "/edit/payment-term/:id" },
    Roles: { path: "/roles" },
    CreateRole: { path: "/create-role" },
    EditRole: { path: "/edit/role/:id" },
    Principals: { path: "/principals" },
    SoftPrincipals: { path: "/pdeleted" },
    CreatePrincipal: { path: "/create-principal" },
    EditPrincipal: { path: "/edit/principal/:id" },
    Industries: { path: "/industries" },
    CreateIndustries: { path: "/create-industries" },
    EditIndustries: { path: "/edit/industries/:id" },
    SubIndustries: { path: "/sub-industries" },
    CreateSubIndustries: { path: "/Create-sub-industries" },
    EditSubIndustries: { path: "/Edit/sub-industries/:id" },
    Departments: { path: "/departments" },
    CreateDepartments: { path: "/create-departments" },
    EditDepartments: { path: "/edit/departments/:id" },
    // Settings1: { path: "/settings1" },
    // Upgrade: { path: "/upgrade" },
    // BootstrapTables: { path: "/tables/bootstrap-tables" },
    // Billing: { path: "/examples/billing" },
    // Invoice: { path: "/examples/invoice" },
    Invoice: { path: "/invoice" },
    Signin: { path: "/sign-in" },
    // Signup: { path: "/examples/sign-up" },
    // ForgotPassword: { path: "/examples/forgot-password" },
    // ResetPassword: { path: "/examples/reset-password" },
    // Lock: { path: "/examples/lock" },
    // NotFound: { path: "/examples/404" },
    // ServerError: { path: "/examples/500" },
    NotFound: { path: "/404" },
    ServerError: { path: "/500" },

    // docs
    // DocsOverview: { path: "/documentation/overview" },
    // DocsDownload: { path: "/documentation/download" },
    // DocsQuickStart: { path: "/documentation/quick-start" },
    // DocsLicense: { path: "/documentation/license" },
    // DocsFolderStructure: { path: "/documentation/folder-structure" },
    // DocsBuild: { path: "/documentation/build-tools" },
    // DocsChangelog: { path: "/documentation/changelog" },

    // components
    // Accordions: { path: "/components/accordions" },
    // Alerts: { path: "/components/alerts" },
    // Badges: { path: "/components/badges" },
    // Widgets: { path: "/widgets" },
    // Breadcrumbs: { path: "/components/breadcrumbs" },
    // Buttons: { path: "/components/buttons" },
    // Forms: { path: "/components/forms" },
    // Modals: { path: "/components/modals" },
    // Navs: { path: "/components/navs" },
    // Navbars: { path: "/components/navbars" },
    // Pagination: { path: "/components/pagination" },
    // Popovers: { path: "/components/popovers" },
    // Progress: { path: "/components/progress" },
    // Tables: { path: "/components/tables" },
    // Tabs: { path: "/components/tabs" },
    // Tooltips: { path: "/components/tooltips" },
    // Toasts: { path: "/components/toasts" },
    // WidgetsComponent: { path: "/components/widgets" }
};